import React, { Component } from 'react';
import Button from '~/Common-Objects/UI/Forms/Button/Button'
import FormError from '~/Common-Objects/UI/Forms/FormError/FormError'
import Icons from '~/Common-Objects/UI/Icons/index'
import LoadingIcons from '~/Common-Objects/LoadingIcons/loadingIcon1'
import TextArea from '~/Common-Objects/UI/Forms/TextArea/TextArea'
import TextInput from '~/Common-Objects/UI/Forms/TextInput/TextInput'
import Toggle from '~/Common-Objects/UI/Forms/Toggle/Toggle'
import { connect } from 'react-redux';
import i18n from '~/i18n';
import axios from '~/data/http/axios';
@connect((store) => {
    return { accountMaster: store.accountMaster, permissionStore: store.permission, siteMaster: store.siteMaster }
})
class unsubOptionsDrawer extends Component {
    constructor(props) {
        super(props)
        this.state = {
            rnd: -1,
            options: {},
            pageLoaded: false,
            saveError: ''
        }
        this.changeValue = this.changeValue.bind(this);
        this.saveValues = this.saveValues.bind(this);
        this.changeText = this.changeText.bind(this);
        this.getOptions = this.getOptions.bind(this);
    }

    componentDidMount() {
        setTimeout(this.getOptions, 1000);
    }
    async getOptions() {
        let options
        let group = {};
        if (this.props.group) {
            group = await axios.get('/group/' + this.props.group.id + '?skipCount=true')
            options = JSON.parse(JSON.stringify(group.data.Group.options || {}));
        } else {
            let account = await axios.get("/accountmaster")
            options = account.data.AccountMaster.options;
        }
        this.setState({ options, pageLoaded: true })
    }


    changeValue(event) {
        let options = this.state.options
        options[event.target.name] = event.target.checked;
        this.setState({ options })
    }
    changeText(event) {
        let options = this.state.options
        options[event.target.name] = event.target.value;
        this.setState({ options })
    }

    saveValues() {
        this.setState({ pageLoaded: false, saveError: '' })
        const onSaved = () => {
            this.props.closeDrawer()
        }
        const onError = () => {
            this.setState({ pageLoaded: true, saveError: i18n.t('company:landing.saveError') })
        }
        if (this.props.group) {
            axios.put('/group/' + this.props.group.id + '/options', this.state.options).then(onSaved).catch(onError);
        } else {
            const account = this.props.accountMaster.accountMaster
            axios.put('/accountMaster', { ...account, options: this.state.options }).then(() => {
                account.options = this.state.options
                onSaved()
            }).catch(onError);
        }
    }
    render() {
        if (!this.state.pageLoaded) return <div><LoadingIcons iconType="2" /></div>
        var thisOpts = this.state.options
        var canChooseGroups = true;
        var showAllNonHiddenGroups = false;
        var fixedGroup = false;
        var unsubscribedText = "You've been Unsubscribed"
        var alreadyUnsubscribedText = "You are already Unsubscribed"
        var unsubButtonText = "Unsubscribe";
        var unsubFromAllText = "unsubscribe from all";

        if (thisOpts && thisOpts.hasOwnProperty("unsubCanChooseGroups")) {
            canChooseGroups = thisOpts.unsubCanChooseGroups
        }
        if (thisOpts && thisOpts.hasOwnProperty("showAllNonHiddenGroups")) {
            showAllNonHiddenGroups = thisOpts.showAllNonHiddenGroups
        }
        if (thisOpts && thisOpts.hasOwnProperty("unsubFixedGroup")) {
            fixedGroup = thisOpts.unsubFixedGroup
        }

        if (thisOpts && thisOpts.hasOwnProperty("unsubButtonText")) {
            unsubButtonText = thisOpts.unsubButtonText
        }
        if (thisOpts && thisOpts.hasOwnProperty("unsubFromAllText")) {
            unsubFromAllText = thisOpts.unsubFromAllText
        }

        if (thisOpts && thisOpts.hasOwnProperty("unsubscribedText")) {
            unsubscribedText = thisOpts.unsubscribedText
        }
        if (thisOpts && thisOpts.hasOwnProperty("alreadyUnsubscribedText")) {
            alreadyUnsubscribedText = thisOpts.alreadyUnsubscribedText
        }

        return <div>
            <h4 className="mar-b25">{i18n.t('company:landing.unsubOptions.title')}</h4>
            <p>{i18n.t('company:landing.unsubOptions.subTitle')}</p>


            <Toggle className="mar-b25" name="unsubCanChooseGroups" label={i18n.t('company:landing.unsubOptions.subscribersCanChooseGroups')} value={canChooseGroups} onChange={this.changeValue} />
            <Toggle className="mar-b25" name="showAllNonHiddenGroups" label={i18n.t('company:landing.unsubOptions.showAllNonHiddenGroups')} value={showAllNonHiddenGroups} onChange={this.changeValue} />
            <Toggle className="mar-b25" name="unsubFixedGroup" label={i18n.t('company:landing.unsubOptions.unsubFixedGroup')} value={fixedGroup} onChange={this.changeValue} />

            <TextInput className="mar-b25" label={i18n.t('company:landing.unsubOptions.unsubButtonText')} placeholder={i18n.t('company:landing.unsubOptions.unsubButtonTextPlace')} name="unsubButtonText" value={unsubButtonText} onChange={this.changeText} />
            <TextInput className="mar-b25" label={i18n.t('company:landing.unsubOptions.unsubFromAllText')} placeholder={i18n.t('company:landing.unsubOptions.unsubFromAllTextPlace')} name="unsubFromAllText" value={unsubFromAllText} onChange={this.changeText} />
            <TextArea className="mar-b25" label={i18n.t('company:landing.unsubOptions.unsubscribeText')} placeholder={i18n.t('company:landing.unsubOptions.unsubscribedText')} name="unsubscribedText" value={unsubscribedText} onChange={this.changeText} />
            <TextArea className="mar-b25" label={i18n.t('company:landing.unsubOptions.alreadyUnsubscribedText')} placeholder={i18n.t('company:landing.unsubOptions.alreadyUnsubscribedTextPlace')} name="alreadyUnsubscribedText" value={alreadyUnsubscribedText} onChange={this.changeText} />

            {this.state.saveError && <FormError className="mar-b25">{this.state.saveError}</FormError>}
            <Button iconRight={<Icons icon="tick" />} className="button-primary" text={i18n.t('translations:save')} onClick={this.saveValues} />

        </div>
    }
}

export default unsubOptionsDrawer;